import { type FC, type JSX, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Link } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { urlResolverGetNewsletter } from '../../../url-handling'
import { LoginRegistrationInputCheckBox } from '../LoginRegistrationInputCheckBox/LoginRegistrationInputCheckBox'

export const LoginRegistrationNewsletterAcceptedCheckBox: FC = () => {
  const config = useGlobalConfigContext()

  const anchor = (text: ReactNode[]): JSX.Element => (
    <Link className="text-s" href={urlResolverGetNewsletter(config)}>
      {text}
    </Link>
  )

  return (
    <LoginRegistrationInputCheckBox
      data-qa-id="register-form-newsletterAccepted"
      field="newsletterAccepted"
    >
      <FormattedMessage
        id="registrationForm.label.check.newsletter.new.text"
        values={{
          anchor,
        }}
      />
    </LoginRegistrationInputCheckBox>
  )
}
